<template>
  <div class="breadcrumb-l d-flex align-items-center">
    <b-container>
      <b-row>
        <b-col :md="actionButton ? 8 : 12" sm="12">
          <p>{{ title }}</p>
          <h2 class="text-white">{{ subtitle }}</h2>
        </b-col>
        <b-col md="4" sm="12" v-if="actionButton">
          <b-button
            :to="actionButtonLink"
            variant="primary"
            size="lg"
          >
            {{actionButtonText}}
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { BContainer, BRow, BCol, BButton } from 'bootstrap-vue'

export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BButton,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    actionButton: {
      type: Boolean,
      default: false,
    },
    actionButtonText: {
      type: String,
      default: '',
    },
    actionButtonLink: {
      type: String,
      default: '',
    },
  },
}
</script>

<style>

</style>
